import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Box, Typography, Divider, Alert } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { API_ROOT } from './config';

function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");  // State for showing messages (success or error)
  const [severity, setSeverity] = useState("success");  // For controlling message style (success or error)
  const [timeoutDuration, setTimeoutDuration] = useState(5000);  // Default timeout duration (in milliseconds)

  const navigate = useNavigate();

  // Effect to automatically clear the message after the specified timeout duration
  useEffect(() => {
    if (message) {
      const timeout = setTimeout(() => {
        setMessage("");  // Clear the message
      }, timeoutDuration);  // Dynamic timeout based on state

      return () => clearTimeout(timeout);  // Clear timeout if component unmounts or message changes
    }
  }, [message, timeoutDuration]);  // Run effect when 'message' or 'timeoutDuration' changes

  // Function to show messages with optional dynamic timeout and severity
  const showMessage = (msg, type = "success", duration = 5000) => {
    setMessage(msg);
    setSeverity(type);
    setTimeoutDuration(duration);  // Set dynamic timeout duration
  };

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      showMessage("Passwords do not match", "error", 5000);
      return;
    }

    // API call for registration
    try {
      const response = await fetch(`${API_ROOT}register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          email: email,
          password: password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Registration successful:", data);
        showMessage("Registration successful! You can now log in.", "success", 5000);

        // Optionally, redirect to the login page after registration
        setTimeout(() => navigate("/login", {
          state: { successMessage: "Registration successful! Please log in." }
        }), 2000); // Redirect after 2 seconds
      } else {
        const errorData = await response.json();
        showMessage(errorData.detail || "Registration failed", "error", 5000);
      }
    } catch (error) {
      console.error("Error during registration:", error);
      showMessage("Something went wrong. Please try again.", "error", 5000);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Typography variant="h4" sx={{ mb: 3 }}>
          Register
        </Typography>

        {message && (
          <Alert severity={severity} sx={{ mb: 3 }}>
            {message}
          </Alert>
        )}
        
        {/* Registration form */}
        <TextField
          label="Username"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirm Password"
          type="password"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mb: 3 }}
          onClick={handleRegister}
        >
          Register
        </Button>

        <Divider sx={{ width: '100%', mb: 3 }}>OR</Divider>

        {/* Back to Login Button */}
        <Box sx={{ mt: 3 }}>
          <Link to="/login">
            <Button variant="text" fullWidth>
              Already have an account? Login
            </Button>
          </Link>
        </Box>
      </Box>
    </Container>
  );
}

export default Register;